import Navbar from '../components/Navbar/Navbar';
import HomeComponent from '../components/Home/Home';
import Footer from '../components/Footer/Footer';

export default function Home() {
    return (
        <div>
            <Navbar/>
            <HomeComponent/>
            <Footer/>
        </div>
    )
}